export enum InviteError {
  UserAlreadyExists = "user_already_exists",
  InviteExpired = "invite_expired",
  SubscriptionExpired = "subscription_expired",
  ErrorMaxSeatsExceeded = "error_max_seats_exceeded",
  EntityNotActive = "entity_not_active",
}
